
import Vue from 'vue'
import { gaEventTracker } from '@/common/utils'


export default Vue.extend({
  props: {
    productId: {
      type: Number,
      required: true
    }
  },
  computed: {
    contactLink(): string {
      return `/contact?product_id=${this.productId}`
    }
  },
  methods:{
    eventTracker(category: string, action: string, label: string) {
      const payload = {
        category:  category,
        action: action,
        label: label
      }
      gaEventTracker(payload)
    }
  }
})
